import { CSSProperties } from 'react';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { TableProps } from './Table';

export type TableVariant = 'default' | 'new-flow';

type TableStyleProps = Pick<
  TableProps,
  'flat' | 'withRowBorders' | 'verticalSpacing' | 'horizontalSpacing' | 'headerStyle' | 'cellStyle'
>;

type TableVariantConfig = {
  tableProps?: Partial<TableStyleProps>;
  columnTitleStyle?: CSSProperties;
  striped?: boolean;
};

const newFlowHeaderStyle: CSSProperties = {
  fontSize: 'var(--mantine-font-size-xs)',
  fontWeight: FONT_WEIGHTS.medium,
  color: 'var(--mantine-color-gray-5)',
  textAlign: 'left',
  verticalAlign: 'top',
  backgroundColor: 'transparent',
  borderBottom: 'none',
};

export const TABLE_VARIANTS: Record<TableVariant, TableVariantConfig> = {
  default: {},
  'new-flow': {
    striped: false,
    columnTitleStyle: { borderBottom: 'none', paddingTop: 12, paddingBottom: 12 },
    tableProps: {
      flat: true,
      withRowBorders: false,
      verticalSpacing: 12,
      horizontalSpacing: 12,
      headerStyle: newFlowHeaderStyle,
    },
  },
};
